module.exports = __webpack_public_path__ + "img/is-deal.be69ae64.png";